<div [ngClass]="length > LIMIT_DESCRIPTION ? 'editor-error' : ''">
  <div *ngIf="isViewMode" [innerHTML]="productForm.description"></div>
  <p-editor
    #editor
    *ngIf="!isViewMode"
    (onTextChange)="onChangeTextEditor($event)"
    [(ngModel)]="productForm.description"
    name="description"
    class="editor"
    [placeholder]="managementPrefix + 'enter-description' | translate | sentenceCase"
    [style]="{ minHeight: '200px' }"
    [readonly]="isViewMode"
  >
    <ng-template pTemplate="header">
      <app-editor-toolbar></app-editor-toolbar>
    </ng-template>
  </p-editor>

  <div *ngIf="!isViewMode && isHint" class="flex justify-between mt-2">
    <small
      id="name-help"
      class="flex justify-end text-xs"
      [ngClass]="length > LIMIT_DESCRIPTION ? 'text-error-500' : 'text-gray-500'"
    >
      {{ length }}/{{ LIMIT_DESCRIPTION }} {{ "common.characters" | translate }}
    </small>
  </div>
</div>
